var _excluded = ["placement", "show", "delayShow", "delayHide", "onHide", "onShow", "container", "target", "renderTarget", "renderOverlay"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { useForwardedRef } from '@adsk/alloy-react-helpers';
import Portal from '@adsk/alloy-react-portal';
import { PLACEMENTS, VARIANTS } from './consts';
import useOverlay from './hooks/useOverlay';
import Arrow from './layout/Arrow';
import Blank from './layout/Blank';
import Body from './layout/Body';
import Container from './layout/Container';
import Target from './layout/Target';

/**
 * React Overlay wrapper component for useOverlay
 */
var Overlay = function Overlay(_ref) {
  var _ref$placement = _ref.placement,
      placementProp = _ref$placement === void 0 ? PLACEMENTS.BOTTOM : _ref$placement,
      showProp = _ref.show,
      delayShow = _ref.delayShow,
      delayHide = _ref.delayHide,
      onHide = _ref.onHide,
      onShow = _ref.onShow,
      _ref$container = _ref.container,
      container = _ref$container === void 0 ? document.body : _ref$container,
      targetRef = _ref.target,
      TargetProp = _ref.renderTarget,
      OverlayProp = _ref.renderOverlay,
      props = _objectWithoutProperties(_ref, _excluded);

  var target = useForwardedRef(targetRef || null);

  var _useOverlay = useOverlay(_objectSpread({
    placement: placementProp,
    show: showProp,
    delayShow: delayShow,
    delayHide: delayHide,
    onHide: onHide,
    onShow: onShow,
    target: target
  }, props)),
      show = _useOverlay.show,
      placement = _useOverlay.placement,
      targetProps = _useOverlay.targetProps,
      overlayProps = _useOverlay.overlayProps,
      arrowProps = _useOverlay.arrowProps,
      handleHide = _useOverlay.handleHide,
      handleToggle = _useOverlay.handleToggle;

  return /*#__PURE__*/React.createElement(React.Fragment, null, TargetProp && /*#__PURE__*/React.createElement(TargetProp, {
    show: show,
    handleToggle: handleToggle,
    targetProps: targetProps
  }), OverlayProp && show ? /*#__PURE__*/React.createElement(Portal, {
    container: container
  }, /*#__PURE__*/React.createElement(OverlayProp, {
    placement: placement,
    handleHide: handleHide,
    targetProps: targetProps,
    overlayProps: overlayProps,
    arrowProps: arrowProps
  })) : null);
};

Overlay.displayName = 'Overlay';
Overlay.propTypes = {
  /**
   * whether the popover is showed or not. should be sent only for
   * controlled elements
   */
  show: PropTypes.bool,

  /**
   * callback to be called on show
   */
  onShow: PropTypes.func,

  /**
   * callback to be called on hide
   */
  onHide: PropTypes.func,

  /**
   * delay before show in milliseconds
   */
  delayShow: PropTypes.number,

  /**
   * delay before hide in milliseconds
   */
  delayHide: PropTypes.number,

  /** overlay position according to Overlay placements. */
  placement: PropTypes.oneOf(Object.values(useOverlay.PLACEMENTS)),

  /** target element ref (get/set).  */
  target: PropTypes.object,

  /** overlay ref to overlay dom element. */
  overlayRef: PropTypes.any,

  /** Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay. */
  rootClose: PropTypes.bool,

  /** Dependency to pass to usePopper's useLayoutEffect hook */
  layoutDependency: PropTypes.any,

  /** Container is Overlay Portal location */
  container: PropTypes.object,

  /**  render prop for Target:
   *    <Target
          show={show}
          handleToggle={handleToggle}
          targetProps={targetProps}
        />
   */
  renderTarget: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),

  /** render prop for Overlay:
   * <Overlay
      placement={placement}
      handleHide={handleHide}
      targetProps={targetProps}
      overlayProps={overlayProps}
      arrowProps={arrowProps}
    />
   */
  renderOverlay: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
};
export default Object.assign(Overlay, {
  VARIANTS: VARIANTS,
  PLACEMENTS: PLACEMENTS,
  Target: Target,
  Container: Container,
  Body: Body,
  Blank: Blank,
  Arrow: Arrow
});
//# sourceMappingURL=Overlay.js.map